import type { JsonSerializer } from './types.js'

export const defaultJsonSerializer: JsonSerializer = JSON
